<template>
  <el-container>
    <el-main class="mybody">
      <div id="login-box">
        <h1>科技云科普活动管理中心</h1>

        <div class="form" :model="form_model">
          <div class="item">
            <i class="fa fa-github-alt" style="font-size:24px"></i>
            <input type="text" placeholder="手机号" v-model="form_model.fphone" />
          </div>
          <div class="item">
            <i class="fa fa-th" style="font-size:24px"></i>
            <input type="password" placeholder="密码" v-model="form_model.fpassword" />
          </div>
        </div>
        <button @click="navi" :disabled="form_model.disabled">登录</button>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      form_model: {
        faccount: '',
        fphone: '',
        fpassword: '',
        disabled: false
      }
    }
  },
  name: '',
  created: function () {
    this.$store.commit('$_removeStorage')
  },
  methods: {
    navi () {
      var url = '/console/login'
      var that = this
      var funSuccess = rsp => {
        console.log(rsp)
        that.form_model.disabled = true
        if (rsp.code === 0) {
          console.log('=====login token=======')
          console.log(rsp.data.token)
          that.$store.commit('$_setToken', rsp.data.token)
          // Toast({ message: '登录成功', type: 'success', duration: 1500}) // ui弹窗提示
          that.$router.push('/home')
        } else {
          that.$message({
            title: '登录失败',
            type: 'error',
            message: '登录失败，请检查用户名或密码！',
            callback: function (action, instance) {
              that.form_model.disabled = false
            }
          })
        }
      }
      global.http(url, this.form_model, funSuccess, null)
    }
  }
}
</script>

<style lang="less" scoped>
.mybody {
  background: url('../assets/bg_login.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
  min-height: 550px;
  width: 100%;
  /*
    margin-top:50%;
    transform: -50%;
    -webkit-transform: -50%;*/
}
#login-box {
  position: absolute;
  top: 130px;
  right: 110px;
  width: 280px;
  height: auto;
  border-radius: 20px;
  text-align: center;
  background: #ffffff30;
  padding: 20px 50px;
}
#login-box h1 {
  color: #fff;
}
#login-box .form .item {
  margin-top: 15px;
}
#login-box .form .item i {
  font-size: 18px;
  color: #fff;
}
#login-box .form .item input {
  width: 180px;
  font-size: 18px;
  border: 0;
  border-bottom: 2px solid #fff;
  padding: 5px 10px;
  background: #ffffff00;
  color: #fff;
}
#login-box button {
  margin-top: 20px;
  width: 190px;
  height: 30px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  background-image: linear-gradient(to right, #74ebd5 0%, #9face6 100%);
  border: 0;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue